import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import { applyTimeAndSeason, loadTheme } from '@/lib/ambient';
import { initializeCapacitorRuntime, registerAppServiceWorker } from '@/lib/appRuntime';
import { AuthProvider } from '@/hooks/useAuth';

import { bootstrapAdSession } from '@/lib/ads';

loadTheme();
applyTimeAndSeason();
setInterval(applyTimeAndSeason, 5 * 60 * 1000);
registerAppServiceWorker();
void initializeCapacitorRuntime();
bootstrapAdSession(); // Doit s'exécuter avant le premier render React

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
